import { Radio, RadioProps } from '@chakra-ui/react';
import React from 'react';

export const CmRadio: React.FC<RadioProps> = ({
  cursor = 'pointer',
  size = 'sm',
  ...rest
}) => {
  // @ts-ignore TS2590
  return <Radio {...{ size, cursor, ...rest }} />;
};
